module.exports = "<ul>\n  <li *ngIf=\"showHome\">\n    <a routerLink=\"/\" routerLinkActive=\"is-active\" [routerLinkActiveOptions]=\"{exact: true}\" (click)=\"menuItemClicked.emit()\">Home</a>\n  </li>\n  <li *ngFor=\"let menuItem of menuItems\">\n    <a [routerLink]=\"menuItem.routerLink\" routerLinkActive=\"is-active\" (click)=\"menuItemClicked.emit()\">{{menuItem.title}}</a>\n  </li>\n</ul>\n"


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/parts/nav-menu/nav-menu.component.html
// module id = ../../../../../src/app/parts/nav-menu/nav-menu.component.html
// module chunks = main